import { AloftArea, AloftPrice, isUndefined } from '@aloft/toolkit-shared';

export const getPricePerSquareFoot = (
  area: AloftArea | undefined,
  cost: AloftPrice | undefined,
): AloftPrice | null =>
  isUndefined(area) || isUndefined(cost)
    ? null
    : AloftPrice.fromNumericPrice((cost?.toNumericPrice() ?? 0) / (area?.toSqFt().unitAmount || 1));
